module.exports = __webpack_public_path__ + "static/img/Rockwood_classification_of_acromioclavicular_joint_dislocation.732a063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/Rockwood_classification_of_acromioclavicular_joint_dislocation.jpg
// module id = fFXt
// module chunks = 2